module.exports = __webpack_public_path__ + "img/link-arrow-rw.84f58a2f.svg";